import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { Component } from 'react';
import { getDimensionsWithDefault } from './getDimensionsWithDefault';
import { Wrapper, AnimatedWrapper } from './lightCardWrappers';
import SpinnerIcon from '@atlaskit/spinner';
import FileIcon from '@atlaskit/icon/glyph/file';
import { getMediaFeatureFlag } from '@atlaskit/media-common';
export var CardLoading = /*#__PURE__*/function (_Component) {
  _inherits(CardLoading, _Component);
  var _super = _createSuper(CardLoading);
  function CardLoading() {
    _classCallCheck(this, CardLoading);
    return _super.apply(this, arguments);
  }
  _createClass(CardLoading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        dimensionsProp = _this$props.dimensions,
        testId = _this$props.testId,
        featureFlags = _this$props.featureFlags;
      var dimensions = getDimensionsWithDefault(dimensionsProp);
      if (getMediaFeatureFlag('newCardExperience', featureFlags)) {
        return /*#__PURE__*/React.createElement(Wrapper, {
          "data-testid": testId || 'media-card-loading',
          "data-test-loading": true,
          dimensions: dimensions
        }, /*#__PURE__*/React.createElement(SpinnerIcon, null));
      }
      return /*#__PURE__*/React.createElement(AnimatedWrapper, {
        "data-testid": testId || 'media-card-loading',
        "data-test-loading": true,
        dimensions: dimensions
      }, /*#__PURE__*/React.createElement(FileIcon, {
        label: "loading",
        size: "medium"
      }));
    }
  }]);
  return CardLoading;
}(Component);